const arrangeToffeePdpPurchase = () => {
  document.querySelectorAll('.shopify-section--main-product .product-info').forEach((productInfo) => {
    const buyBlock = productInfo.querySelector('[data-block-type="buy-buttons"]');
    const quantityBlock = productInfo.querySelector('[data-block-type="quantity-selector"]');
    const wishlistButton = productInfo.querySelector('.toffee-wishlist-button--pdp');
    const bundleCta = productInfo.querySelector('.toffee-pdp-bundle-cta');
    const isAccessoryPdp = Boolean(document.querySelector('.shopify-section--toffee-accessory-editorial'));
    let purchaseRow = productInfo.querySelector('.toffee-pdp-purchase-row');

    if (buyBlock && (wishlistButton || isAccessoryPdp)) {
      if (!purchaseRow) {
        purchaseRow = document.createElement('div');
        purchaseRow.className = 'toffee-pdp-purchase-row';
        buyBlock.parentNode.insertBefore(purchaseRow, buyBlock);
      }

      if (quantityBlock && quantityBlock.parentElement !== purchaseRow) purchaseRow.append(quantityBlock);
      if (buyBlock.parentElement !== purchaseRow) purchaseRow.append(buyBlock);
      if (wishlistButton && wishlistButton.parentElement !== purchaseRow) purchaseRow.append(wishlistButton);
      if (bundleCta && bundleCta.parentElement !== purchaseRow) purchaseRow.append(bundleCta);
    }

  });
};

const scheduleToffeePdpPurchase = () => window.requestAnimationFrame(arrangeToffeePdpPurchase);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', scheduleToffeePdpPurchase, { once: true });
} else {
  scheduleToffeePdpPurchase();
}

new MutationObserver(scheduleToffeePdpPurchase).observe(document.documentElement, { childList: true, subtree: true });

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-toffee-scroll-to-purchase]');
  if (!trigger) return;

  const target = document.getElementById('toffee-pdp-purchase');
  if (!target) return;

  event.preventDefault();

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });

  const productInfo = target.closest('.product-info');
  const focusScope = productInfo?.querySelector('[data-toffee-pdp-variant-picker]')
    || productInfo?.querySelector('[data-block-type="buy-buttons"]');
  const focusTarget = focusScope?.querySelector('a[href], button:not(:disabled), input:not(:disabled), select:not(:disabled), textarea:not(:disabled), [tabindex]:not([tabindex="-1"])');

  window.setTimeout(() => focusTarget?.focus({ preventScroll: true }), reduceMotion ? 0 : 260);
});

